var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:['primary-btn text-center mb-4', _vm.wrapperClass],attrs:{"type":_vm.type},on:{"click":_vm.emitClickEvent}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }